export default __webpack_public_path__ + "static/media/dream_text_front.298ee784.gif";